import React from 'react';
import { PhotoPlaceholder } from '../components/PhotoPlaceholder';
import { NeedFromAbby } from '../components/NeedFromAbby';
import { Button } from '../components/Button';
import { ClientProof } from '../components/ClientProof';
import { TickDivider } from '../components/TickDivider';
import { usePageMeta } from '../hooks/usePageMeta';
import { images } from '../data/images';
const CREDENTIALS = [{
  value: '16+',
  label: 'Years of experience'
}, {
  value: 'Certified',
  label: 'Astrologer'
}, {
  value: 'Psychology',
  label: 'Background'
}, {
  value: 'Vedic',
  label: 'Specialist (Jyotish)'
}];
const VEDIC = [{
  n: 'I',
  title: 'The real sky',
  body: 'Vedic astrology uses the sidereal zodiac, aligned with the constellations as they actually sit in the sky today.'
}, {
  n: 'II',
  title: 'Built on timing',
  body: 'Planetary periods, called dashas, map the chapters of your life, so a reading speaks to when, not only what.'
}, {
  n: 'III',
  title: 'The whole chart',
  body: 'Your moon and rising sign carry as much weight as your sun. Every house, every planet, read together.'
}];
export function About() {
  usePageMeta('About Abby | Vedic Astrologer', 'Abby is a certified Vedic astrologer with a background in Psychology and 16+ years of experience reading birth charts, transits and synastry.');
  return <>
      <section aria-labelledby="about-title" className="grid lg:grid-cols-[minmax(0,1.1fr)_minmax(0,1fr)]" data-id="element-521" data-mp="2dg4dcms23z6e">
        <div className="gutter flex flex-col justify-center py-[clamp(4rem,8vw,10rem)]" data-id="element-522" data-mp="28icmlw35ej3s">
          <p className="t-label flex items-center gap-3 text-graphite" data-id="element-523" data-mp="2m9hfmfc0gd55">
            <span className="t-numeral text-gold-deep" data-id="element-524" data-mp="2i7cp3pguzwmq">IV</span>
            <span aria-hidden="true" className="text-gold" data-id="element-525" data-mp="2i7w7166iel0r">
              ·
            </span>
            About Abby
          </p>
          <h1 id="about-title" className="t-display mt-6 max-w-[15ch]" data-id="element-526" data-mp="2w4suqyrbzmdf">
            Astrology began as a pull toward understanding people.
          </h1>
          <div className="mt-8 flex flex-wrap items-center gap-3" data-id="element-527" data-mp="1ovxtvvnu4wdr">
            <p className="t-label text-charcoal" data-id="element-528" data-mp="1svq6cjgcnmoe">Abby · Vedic Astrologer</p>
            <NeedFromAbby data-id="element-529" data-mp="1stvndaon24my">public last name</NeedFromAbby>
          </div>
        </div>
        <PhotoPlaceholder src={images.portrait} alt="Portrait of Abby in soft morning light" note="brand portrait" eager className="aspect-[4/5] lg:aspect-auto lg:min-h-[85vh]" data-id="element-530" data-mp="1xt87hno4kxlu" />
      </section>

      <section aria-labelledby="story-title" className="gutter section" data-id="element-531" data-mp="27n8iu7a02z30">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,2fr)] lg:gap-[clamp(3rem,6vw,9rem)]" data-id="element-532" data-mp="2ciw6ujcqxm6x">
          <h2 id="story-title" className="t-label text-graphite lg:sticky lg:top-28 lg:self-start" data-id="element-533" data-mp="2gmc5tmcafyms">
            Her story
          </h2>
          <div className="max-w-[70ch] space-y-6 text-[clamp(1.05rem,0.98rem+0.25vw,1.3rem)] leading-[1.75] text-graphite" data-id="element-534" data-mp="m7t25gg0fp36">
            <p className="t-lead !text-[clamp(1.3rem,1.05rem+0.8vw,2rem)] !leading-[1.45] text-charcoal" data-id="element-535" data-mp="r62wjotwulnq">
              Abby has studied astrology since she was about twelve or thirteen, and kept seeing how accurate it was, down to the smallest
              details of people's lives.
            </p>
            <p data-id="element-536" data-mp="9wsbk3a8mx0n">
              She specializes in Vedic astrology, or Jyotish, the system from India that is thousands of years old. In her words, it is
              “deep and complex; you never stop learning.”
            </p>
            <p data-id="element-537" data-mp="12lpft2hm6tae">
              She learned from several Vedic astrologers and others, and is largely self-taught through her own research. She spent seven
              years mastering birth charts before moving into transits and synastry.
            </p>
            <p data-id="element-538" data-mp="ompzqj863mpu">
              Today she is a certified astrologer with a background in Psychology and more than sixteen years of experience. “Everybody
              comes into the world with a different set of energy,” she says. Astrology helps us understand and appreciate one another.
            </p>
          </div>
        </div>
      </section>

      <section aria-label="Pull quote" className="relative overflow-hidden bg-stone" data-id="element-539" data-mp="112e9p94m1zcw">
        <img src={images.duskSky} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-60" data-id="element-540" data-mp="15vh8bvo8vyzy" />
        <div className="gutter relative py-[clamp(5rem,10vw,12rem)]" data-id="element-541" data-mp="r3q97o8o62wy">
          <figure className="mx-auto max-w-[60rem] bg-white/80 p-[clamp(2rem,5vw,5rem)] text-center backdrop-blur-sm" data-id="element-542" data-mp="w5nusp4jl9t2">
            <blockquote className="font-serif text-[clamp(1.6rem,1.1rem+1.8vw,3.2rem)] italic font-light leading-[1.3] text-charcoal" data-id="element-543" data-mp="1jv9ynpvv0d7e">
              “The ultimate goal of astrology is ascending the limitations you come into the world with: understanding that you create the
              circumstances of your life, so you can become self-aware and more powerful.”
            </blockquote>
            <figcaption className="t-label mt-8 text-graphite" data-id="element-544" data-mp="3vipzv45zzpih">Abby</figcaption>
          </figure>
        </div>
      </section>

      <section aria-labelledby="credentials-title" className="gutter py-[clamp(3.5rem,6vw,7rem)]" data-id="element-545" data-mp="3dvybc7wuofc">
        <h2 id="credentials-title" className="sr-only" data-id="element-546" data-mp="3s3wsh13zie3d">
          Credentials
        </h2>
        <dl className="grid grid-cols-2 gap-y-10 lg:grid-cols-4 lg:divide-x lg:divide-stone" data-id="element-547" data-mp="3n5d7b2x7t6c2">
          {CREDENTIALS.map(c => <div key={c.label} className="lg:px-[clamp(1.5rem,3vw,4rem)] lg:first:pl-0" data-id="element-548" data-mp="v9b0w8v7b13">
              <dt className="sr-only" data-id="element-549" data-mp="39bcf6s0rqhko">{c.label}</dt>
              <dd className="text-[clamp(1.75rem,1.3rem+1.4vw,3.25rem)] font-light leading-none text-charcoal" data-id="element-550" data-mp="39c44jl3rvj2i">{c.value}</dd>
              <dd className="t-label mt-3 text-[0.64rem] text-graphite" data-id="element-551" data-mp="34aoh5me4h0gy">{c.label}</dd>
            </div>)}
        </dl>
        <div className="mt-8" data-id="element-552" data-mp="3ea5l9zdq76at">
          <NeedFromAbby data-id="element-553" data-mp="3e9x8s8lim305">certifying body, if shown</NeedFromAbby>
        </div>
      </section>

      <div className="gutter" data-id="element-554" data-mp="2qjtfov5ydlne">
        <TickDivider data-id="element-555" data-mp="2qj05fk7sce0i" />
      </div>

      <section aria-labelledby="vedic-title" className="gutter section" data-id="element-556" data-mp="2lm9sv6v6w0ju">
        <p className="t-label text-graphite" data-id="element-557" data-mp="2lk70whah7xch">Jyotish</p>
        <h2 id="vedic-title" className="t-h2 mt-5 max-w-[16ch]" data-id="element-558" data-mp="3b9dtfot6yaam">
          What makes Vedic different.
        </h2>
        <ul className="mt-[clamp(3rem,5vw,6rem)] grid gap-[clamp(1rem,1.6vw,2rem)] md:grid-cols-3" data-id="element-559" data-mp="3fa7emaf91azt">
          {VEDIC.map(v => <li key={v.n} className="flex h-full flex-col bg-cream p-[clamp(1.75rem,2.6vw,3.25rem)]" data-id="element-560" data-mp="3p1k979sfmf9j">
              <span className="t-numeral text-lg text-gold-deep" data-id="element-561" data-mp="2sbb0x01fpv82">{v.n}</span>
              <h3 className="t-h3 mt-10" data-id="element-562" data-mp="2sde0aaoh90pg">{v.title}</h3>
              <p className="mt-4 text-graphite" data-id="element-563" data-mp="2wdxv37lkvs8f">{v.body}</p>
            </li>)}
        </ul>
      </section>

      <section aria-labelledby="about-cta" className="dusk-field" data-id="element-564" data-mp="31b7v1h6lfmai">
        <div className="gutter grid items-center gap-10 py-[clamp(4rem,8vw,9rem)] lg:grid-cols-[minmax(0,1.4fr)_minmax(0,1fr)]" data-id="element-565" data-mp="36blsy6ehdfut">
          <div data-id="element-566" data-mp="gkywpj0ld41o">
            <h2 id="about-cta" className="t-h2 max-w-[18ch]" data-id="element-567" data-mp="gligl59sy2ic">
              Begin with your blueprint.
            </h2>
            <div className="mt-8 flex flex-wrap gap-3" data-id="element-568" data-mp="lmoah6f77vtg">
              <Button to="/readings#book" size="lg" data-id="element-569" data-mp="261kq3ngan6m4">
                Book a Reading
              </Button>
              <Button to="/readings" variant="outline" size="lg" data-id="element-570" data-mp="214b3sgo7bb2i">
                View Readings
              </Button>
            </div>
          </div>
          <ClientProof index={0} data-id="element-571" data-mp="1re9clg0jxcjd" />
        </div>
      </section>
    </>;
}